import { ComuniComponent } from './comuni.component';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { EconomiaComponent } from '../economia/economia.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    NgbModule
  ],
  declarations: [ComuniComponent],
  exports: [ComuniComponent]
})
export class ComuniModule { }
